import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, FolderOpen } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader, Empty } from "@/components/common";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export default function Dossiers() {
  const { can } = useApp();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", subject: "", context: "" });
  const load = () => api.get("/dossiers").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/dossiers", form); setOpen(false); setForm({ title: "", subject: "", context: "" }); load(); toast.success("Dossier créé"); } catch (x) { toast.error(errMsg(x)); }
  };
  return (
    <div>
      <PageHeader eyebrow="MADENGI REPORT" title="Dossiers & rapports" desc="Dossiers d'investigation isolés, revue des hypothèses et génération de rapports PDF, DOCX, HTML, CSV et JSON (11 modèles).">
        {can("admin", "analyst") && (
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button data-testid="dossier-create-open" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm flex items-center gap-2"><Plus size={14} />Nouveau dossier</button></DialogTrigger>
            <DialogContent><DialogHeader><DialogTitle>Nouveau dossier d'investigation</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <input data-testid="dossier-title-input" required minLength={3} placeholder="Intitulé" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="w-full h-10 px-3 rounded border bg-background text-sm" />
                <input data-testid="dossier-subject-input" placeholder="Objet" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full h-10 px-3 rounded border bg-background text-sm" />
                <textarea data-testid="dossier-context-input" placeholder="Contexte et cadre légal de l'investigation" rows={4} value={form.context} onChange={(e) => setForm({ ...form, context: e.target.value })} className="w-full p-3 rounded border bg-background text-sm" />
                <button data-testid="dossier-create-submit" className="w-full h-10 rounded-md bg-primary text-primary-foreground text-sm">Créer</button>
              </form>
            </DialogContent>
          </Dialog>)}
      </PageHeader>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="dossier-list">
        {list.map((d, i) => (
          <Link key={d.id} to={`/dossiers/${d.id}`} data-testid={`dossier-card-${d.reference}`} style={{ animationDelay: `${i * 40}ms` }} className="panel p-5 hover:border-primary/50 transition-colors fade-up group">
            <div className="flex items-center justify-between"><span className="font-mono text-xs text-primary">{d.reference}</span><span className={`text-[10px] font-mono px-1.5 py-0.5 rounded border ${d.status === "active" ? "text-emerald-500 border-emerald-500/40" : "text-muted-foreground"}`}>{d.status}</span></div>
            <div className="font-semibold mt-2 group-hover:text-primary flex items-start gap-2"><FolderOpen size={15} className="mt-0.5 shrink-0" />{d.title}</div>
            <div className="text-xs text-muted-foreground mt-2 line-clamp-2">{d.subject || "—"}</div>
            <div className="flex justify-between text-[10px] font-mono text-muted-foreground mt-4 pt-3 border-t"><span>{d.result_count} éléments</span><span>{d.classification}</span><span>{fmtDate(d.updated_at)}</span></div>
          </Link>))}
      </div>
      {!list.length && <Empty>Aucun dossier.</Empty>}
    </div>
  );
}
